var map = {
	"./advantages/script.js": [
		857,
		857
	],
	"./blog/script.js": [
		829,
		829
	],
	"./hero/script.js": [
		864,
		864
	],
	"./popular-courses/script.js": [
		919,
		919
	],
	"./testimonials/script.js": [
		8,
		8
	],
	"./trust/script.js": [
		856,
		856
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 160;
module.exports = webpackAsyncContext;